import React from 'react';

import { SvgIcon, type SvgIconProps } from '@mui/material';

const IvyIcon = ({ ...props }: SvgIconProps) => {
	return (
		<SvgIcon
			width='23'
			height='16'
			viewBox='0 0 23 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.3255 4.58277C11.5278 4.58277 12.5024 3.64386 12.5024 2.48564C12.5024 1.32743 11.5278 0.388519 10.3255 0.388519C9.12315 0.388519 8.14852 1.32743 8.14852 2.48564C8.14852 3.64386 9.12315 4.58277 10.3255 4.58277ZM3.10932 3.34003C1.72253 2.62545 0.972694 1.56654 0.771125 1.1264C0.636744 1.37236 0.376043 2.05845 0.247039 2.67982L0.244521 2.69196C0.0808405 3.48015 -0.392365 5.75885 0.690496 7.8838C1.49695 9.46635 2.34765 9.9403 3.50496 10.5851C3.90968 10.8106 4.35188 11.057 4.84281 11.379C6.47966 12.4526 7.46319 14.1105 7.82601 14.7577C7.80044 14.5891 7.77286 14.3907 7.74224 14.1707C7.56372 12.8872 7.28225 10.8637 6.69724 9.67024C6.07326 8.39729 4.72187 7.23654 4.07685 6.83524C4.35904 6.95175 5.05244 7.2935 5.56846 7.72846C5.62053 7.77236 5.67235 7.81575 5.72391 7.85893C6.31086 8.35042 6.86376 8.81345 7.38257 9.67024C7.94696 10.6023 8.43072 11.9227 8.6726 13.0101C8.91448 14.0975 9.23699 14.5765 9.39825 14.6024C9.5595 14.6282 10.4303 14.0678 10.8899 13.3208C11.493 12.3402 11.5321 12.2426 11.9304 11.2495L11.9319 11.2457L11.9324 11.2445C11.9594 11.1771 11.9881 11.1056 12.0186 11.0295C12.533 9.74954 13.3087 8.03914 14.3165 6.95174C14.5032 6.75037 14.6732 6.55965 14.8364 6.37662C15.5544 5.57133 16.1396 4.91502 17.4207 4.15558C18.6785 3.40993 20.9011 2.78338 21.8552 2.56332C21.4655 2.49859 20.5006 2.36137 19.7589 2.3303C18.8317 2.29147 17.461 2.40797 16.0903 3.06818C14.7197 3.72839 13.6312 4.73811 12.4621 6.09736C11.5308 7.18014 10.5755 8.91753 10.2092 9.66076C10.2313 9.60034 10.2249 9.35062 10.0433 8.73818C9.80138 7.92264 9.39825 6.56339 7.90665 5.47599C7.03391 4.83975 6.13357 4.5226 5.18948 4.19003C4.52001 3.95421 3.82854 3.71063 3.10932 3.34003ZM22.4599 3.92256C21.882 3.87078 20.3152 3.95363 18.6704 4.69928C16.6144 5.63133 15.0019 7.68962 14.3165 9.01003C13.9933 9.63272 13.6521 10.3937 13.3184 11.138C12.9446 11.972 12.58 12.7851 12.2605 13.3596C11.7768 14.2295 10.9302 15.1719 10.5673 15.5344C11.3871 15.6768 13.3087 15.7208 14.4375 14.7577C15.7911 13.6027 16.2542 12.1619 16.4677 11.498L16.4806 11.4578C16.4849 11.4442 16.4893 11.4308 16.4935 11.4178C16.5126 11.3586 16.5374 11.2799 16.5672 11.1848L16.5674 11.1844C16.8509 10.2821 17.5976 7.9056 18.5091 6.64106C19.4137 5.3863 20.0532 4.98996 20.5001 4.71295C20.5511 4.68134 20.5996 4.65121 20.6458 4.62161C21.179 4.27921 21.6685 4.14644 22.0667 4.0385C22.2104 3.99951 22.3422 3.96378 22.4599 3.92256Z'
				fill='url(#paint0_linear_731_12110)'
			/>
			<defs>
				<linearGradient
					id='paint0_linear_731_12110'
					x1='12.9459'
					y1='1.00989'
					x2='8.10696'
					y2='13.2536'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#54B948' />
					<stop offset='0.163593' stopColor='#1EC86A' />
					<stop offset='1' stopColor='#2682C5' />
				</linearGradient>
			</defs>
		</SvgIcon>
	);
};

export default IvyIcon;
